import "./Sidebar.css";
import UploadImage from "./UploadImage";
import { useAuth } from "./contexts/AuthContext";
import { Image } from "@chakra-ui/react";

export default function Sidebar() {
  var { currentUser } = useAuth();
  return (
    <div className="sidebar">
      {/* <p>(Sidebar template)</p> */}
      {/* <Image src="https://www.pngkit.com/png/full/190-1901876_transparent-sidebar-masterpost-transparent-tumblr-sidebar-gif.png"></Image> */}
      {/* <Image src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/MEMA-Logo.png/1280px-MEMA-Logo.png"></Image> */}
      {/*{currentUser && <UploadImage />}*/}
    </div>
  );
}
